module.exports = __webpack_public_path__ + "img/sendmail.fa53acbd.gif";